import { motion } from 'framer-motion';
import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLang } from '@/context/LanguageContext';

const FAQSection = () => {
  const { t, translations, lang } = useLang();
  const [openIndex, setOpenIndex] = useState(null);
  const items = translations.faq.items;

  return (
    <section data-testid="faq-section" className="py-24 md:py-32 bg-[#F5F1EC]">
      <div className="px-5 md:px-10 lg:px-14 max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#111] mb-4">
            {t('faq.title')}
          </h2>
          <p className="text-base text-[#555]">{t('faq.desc')}</p>
        </motion.div>

        <div className="space-y-3">
          {items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="border border-[#D9D3CC] rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left"
                data-testid={`faq-item-${i}`}
              >
                <span className="font-medium text-[#111] text-sm pr-4">{item.q[lang]}</span>
                <ChevronDown
                  size={18}
                  className={`text-[#888] flex-shrink-0 transition-transform duration-300 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-[#555] leading-relaxed">{item.a[lang]}</p>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
